import { complement } from 'ramda';

import isUndefined from './isUndefined';

/**
 * Checks if input value is complement `undefined`.
 *
 * @func isNotUndefined
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/0.0.1|v0.0.1}
 * @category Type
 * @sig * -> Boolean
 * @param {*} val The value to test
 * @return {Boolean}
 * @see {@link RA.isUndefined|isUndefined}
 * @example
 *
 * RA.isNotUndefined(1); //=> true
 * RA.isNotUndefined(undefined); //=> false
 * RA.isNotUndefined(null); //=> true
 */
var isNotUndefined = /*#__PURE__*/complement(isUndefined);

export default isNotUndefined;


//////////////////
// WEBPACK FOOTER
// ./node_modules/ramda-adjunct/es/isNotUndefined.js
// module id = 728
// module chunks = 0